var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreePlanBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8331 1.66699L3.41094 10.5735C3.12026 10.9223 2.97492 11.0967 2.9727 11.244C2.97077 11.3721 3.02783 11.4939 3.12744 11.5744C3.24201 11.667 3.46904 11.667 3.92308 11.667H9.99972L9.16639 18.3337L16.5885 9.42711C16.8792 9.07831 17.0245 8.9039 17.0267 8.75661C17.0287 8.62856 16.9716 8.50674 16.872 8.42625C16.7574 8.33366 16.5304 8.33366 16.0764 8.33366H9.99972L10.8331 1.66699Z",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreePlanBadge);
export default __webpack_public_path__ + "static/media/freePlanBadge.3dfb767cf03c9ba8604137c6a6e04461.svg";
export { ForwardRef as ReactComponent };